import React from "react";
import { NavLink } from "react-router-dom";
import "./MenuBar.css";

const MenuBar = () => {
  return (
    <nav className="menu-bar">
      <div className="menu-container">
        <div className="logo">eCRF</div>
        <ul className="menu-items">
          <li>
            <NavLink
              to="/eCRF/forms/as7dk9f3n5v2x/subjectlist"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Subject List
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/eCRF/forms/as7dk9f3n5v2x/newcase"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              New Case
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/eCRF/forms/as7dk9f3n5v2x/api-test"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              API Test
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Home
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default MenuBar;
